import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getDetails } from '@/utils/getData';
import PollingEvent from '@/utils/PollingEvent';
import { helpCenterTracking } from '@/utils/track';
import store from '@/store';
import Footer from '@/components/Footer';
import Modal from '@/components/Modal';
import styles from './index.module.less';

const Details: React.FC = () => {
  const { t } = useTranslation();
  const pollingEventRef = useRef(new PollingEvent());

  const history = useHistory();
  const splitPath = history.location.pathname.split('/');
  const id = splitPath[2];
  // html 片段
  const [htmlFragment, setHtmlFragment] = useState('');

  useEffect(() => {
    // 动态设置title，需要客户端提供bridge
    document.title = t('title');

    const fetchData = () => {
      const data = getDetails(id);
      if (!data) {
        return history.replace('/');
        //跳转到错误
      }
      setHtmlFragment(data.content);
    };
    fetchData();
  }, [t, id, history]);

  const [isLogin, setIsLogin] = useState(false);
  const getLoginStatus = useCallback(() => {
    try {
      (window as MyWindow).WebViewJavascriptBridge.callHandler(
        'userInfo',
        {},
        (res) => {
          pollingEventRef.current.clear();
          if (res && res.isLogin) {
            setIsLogin(true);
          }
        },
      );
    } catch (e) {
      return e;
    }
  }, []);

  useEffect(() => {
    // 获取登陆态
    const pollingEvent = pollingEventRef.current;
    pollingEvent.start(50, getLoginStatus, 10);
    return () => {
      pollingEvent.clear();
    };
  }, [getLoginStatus]);

  useEffect(() => {
    helpCenterTracking({
      operation: 'view',
      page: 'help_centre_faq',
      data: {
        article_url: window.location.href,
      },
    });
    // when unmount detail page, hide popup
    return () => {
      const { isModalShow } = store.getState().detail;
      isModalShow && Modal.hide();
    };
  }, []);

  return (
    <div>
      <div
        dangerouslySetInnerHTML={{ __html: htmlFragment }}
        className={styles.fragmentWrapper}
      />
      <Footer isLogin={isLogin} />
    </div>
  );
};

export default Details;
